import React from 'react'
import { useTranslation } from 'react-i18next'

const Boolean = ({ value }) => {
    const { t } = useTranslation()
    return <>{t(`/common:${value}`)}</>
}

export default Boolean